<div class="row position-relative">
    <div class="col-xs-12 form-horizontal">
        <div class="form-group my-2">
            <span
                class="col-xs-3 control-label inline"
                translate="ACTIVE"
                [id]="'active-label-' + employee.employeeId + employee.workHourId"
            ></span>
            <app-checkbox
                [id]="'active-' + employee.employeeId + employee.workHourId"
                [attr.aria-labelledby]="'active-label-' + employee.employeeId + employee.workHourId"
                [disable]="employee.updating"
                [(ngModel)]="employee.isActive"
                (change)="toggleActiveChanged()"
            ></app-checkbox>
        </div>
        @if (employee.rideSharingRole && isRideSharingEnabledOnClient && employee.transport !== transportType.Bicycle) {
            <div class="form-group my-2">
                <span
                    class="col-xs-3 control-label d-flex"
                    translate="RIDE_SHARING"
                    [id]="'rideshare-label-' + employee.employeeId + employee.workHourId"
                >
                    <app-info-tooltip
                        class="my-auto ml-2"
                        appCustomPopover
                        popoverText="RIDE_SHARING_ROLE_INFO"
                        placement="top"
                        popoverType="warning"
                        iconSize="sm"
                    >
                    </app-info-tooltip>
                </span>
                <app-checkbox
                    [id]="'rideshare-' + employee.employeeId + employee.workHourId"
                    [attr.aria-labelledby]="'rideshare-label-' + employee.employeeId + employee.workHourId"
                    [disable]="employee.updating || !employee.isActive"
                    [(ngModel)]="employee.rideSharing"
                    (change)="toggleRideSharingChanged()"
                ></app-checkbox>
            </div>
        }
        @if (employee.rideSharingRole && employee.rideSharing && isRideSharingEnabledOnClient) {
            <div class="form-group my-2">
                <span class="col-xs-3 d-flex" translate="RIDE_SHARING_ROLE">
                    <app-info-tooltip
                        class="ml-2 my-auto"
                        appCustomPopover
                        popoverText="RIDE_SHARING_ROLE_INFO"
                        placement="top"
                        popoverType="warning"
                        iconSize="sm"
                    >
                    </app-info-tooltip>
                </span>
                <span>{{ employee.rideSharingRole | translate }}</span>
            </div>
        }
        <div class="form-group my-2">
            <span class="col-xs-3 control-label" translate="COMPETENCE"
                  [id]="'competence-' + employee.employeeId + employee.workHourId"></span>
            <div class="col-xs-3">
                <app-dropdown
                    [attr.aria-labelledby]="'competence-' + employee.employeeId + employee.workHourId"
                    [(ngModel)]="employee.skillLevelId"
                    [disable]="employee.updating"
                    [items]="skillLevelDropdownItems$ | async"
                    (change)="skillLevelChanged()"
                ></app-dropdown>
            </div>
        </div>
        <div class="form-group my-2">
            <span class="col-xs-3 control-label" translate="TRANSPORT"
                  [id]="'transport-' + employee.employeeId + employee.workHourId"></span>
            <div class="col-xs-3">
                <app-dropdown
                    [attr.aria-labelledby]="'transport-' + employee.employeeId + employee.workHourId"
                    data-qa="qa-transport-dropdown"
                    [(ngModel)]="employee.transport"
                    [disable]="employee.updating"
                    [items]="transportDropdownItems"
                    (change)="transportChanged()"
                ></app-dropdown>
            </div>
        </div>
        <div class="form-group my-2">
            <span class="col-xs-3 control-label" translate="SHIFT_TIME"></span>
            <div class="shift-hours-container" [formGroup]="shiftTimeForm">
                <app-time-picker
                    [ngClass]="{
                'has-error':
                    shiftTimeForm.controls['fromTime'].errors || (shiftTimeForm.errors && shiftTimeForm.errors.dateAndTimeGreaterThanOrEqual) || (shiftTimeForm.errors && shiftTimeForm.errors.timeOverlaps)
            }"
                    formControlName="fromTime"
                    [disable]="updating"
                    (change)="fromTimeChanged()"
                ></app-time-picker>
                <span class="time-separator"></span>
                <app-time-picker
                    class='toTime mr-1'
                    [ngClass]="{
                'has-error': shiftTimeForm.controls['toTime'].errors || shiftTimeForm.errors?.dateAndTimeGreaterThanOrEqual || shiftTimeForm.errors?.timeOverlaps
            }"
                    formControlName="toTime"
                    [disable]="updating"
                    (change)="toTimeChanged()"
                    appCustomPopover
                    placement="top"
                    popoverType="error"
                    [popoverTextValidation]="shiftTimeForm.errors?.dateAndTimeGreaterThanOrEqual ? 'TASK_END_TIME_VALIDATION' : shiftTimeForm.errors?.timeOverlaps ? 'SHIFT_TIME_OVERLAP' : ''"
                ></app-time-picker>
                @if (employee.shiftCode) {
                    <span class="mx-1">({{ employee.shiftCode }})</span>
                }
                @if (shiftSplitFeatureEnabled | async) {
                    <app-tooltip
                        class="ml-1"
                        appCustomPopover
                        popoverText="SPLIT_SHIFT_TOOLTIP"
                        placement="top"
                    >
                        <ng-container icon>
                            <button
                                (click)="openSplitShiftModal()"
                                id="splitFormButton" class="btn btn-primary my-auto"
                            >
                                <span>
                                    {{ 'SPLIT' | translate }}
                                </span>
                            </button>
                        </ng-container>
                    </app-tooltip>
                }
            </div>
        </div>
        <div class="form-group my-2">
            <span class="col-xs-3 control-label" translate="SHIFT_TYPE"></span>
            <span class="col-xs-3 control-label">
                {{ employee.shiftType }}
            </span>
        </div>
        @if (showRoster) {
            <div class="form-group my-2">
                <span class="col-xs-3 control-label" translate="ROSTER_NAME"></span>
                @if (employee.rosterDepartmentName) {
                    <span class="col-xs-3 pl-0">
                        {{ employee.rosterDepartmentName }}
                    </span>
                }
                @if (!employee.rosterDepartmentName && isCriticalRosterFeatureEnabled | async) {
                    <div class="col-xs-3 d-flex flex-row"
                    >
                        <app-dropdown
                            class="pr-1"
                            data-qa="qa-roster-dropdown"
                            [(ngModel)]="employee.rosterDepartmentId"
                            [disable]="employee.updating"
                            [items]="rosterDropdownItems | async"
                            (change)="rosterChanged()"
                        ></app-dropdown>
                        <app-tooltip
                            appCustomPopover
                            placement="top"
                            popoverType="warning"
                            [popoverText]="rosterTooltipMessage"
                        >
                            <ng-container icon>
                                <span class="vismaicon vismaicon-md vismaicon-filled vismaicon-warning"></span>
                            </ng-container>
                        </app-tooltip>
                    </div>
                }
            </div>
        }
    </div>
    <app-spinner [overlay]="true" [visible]="updating"></app-spinner>
</div>
